import {
  ToolOutlined,
  RiseOutlined,
  TeamOutlined,
  ExperimentOutlined,
  CheckSquareOutlined,
  ReadOutlined,
  SafetyCertificateOutlined,
  InboxOutlined,
  CarOutlined,
} from '@ant-design/icons';
import type { SidebarConfig } from './types';

export const operationsSidebar: SidebarConfig = {
  module: 'operations',
  titleKey: 'common:nav.operations',
  icon: <ToolOutlined />,
  sections: [
    {
      key: 'execution',
      labelKey: 'operations:sidebar.sections.execution',
      items: [
        { key: 'site-progress', path: '/operations/site-progress', labelKey: 'operations:pages.siteProgress', icon: <RiseOutlined /> },
        { key: 'resources', path: '/operations/resources', labelKey: 'operations:pages.resources', icon: <TeamOutlined /> },
        { key: 'consumption', path: '/operations/consumption', labelKey: 'operations:pages.consumption', icon: <ExperimentOutlined /> },
      ],
    },
    {
      key: 'closeOut',
      labelKey: 'operations:sidebar.sections.closeOut',
      items: [
        { key: 'close-out', path: '/operations/close-out', labelKey: 'operations:pages.closeOut', icon: <CheckSquareOutlined /> },
        { key: 'om-manuals', path: '/operations/om-manuals', labelKey: 'operations:pages.omManuals', icon: <ReadOutlined /> },
        { key: 'warranty', path: '/operations/warranty', labelKey: 'operations:pages.warranty', icon: <SafetyCertificateOutlined /> },
      ],
    },
    {
      key: 'assets',
      labelKey: 'operations:sidebar.sections.assets',
      items: [
        { key: 'inventory', path: '/operations/inventory', labelKey: 'operations:pages.inventory', icon: <InboxOutlined /> },
        { key: 'assets', path: '/operations/assets', labelKey: 'operations:pages.assets', icon: <CarOutlined /> },
      ],
    },
  ],
};
